<script setup lang="ts">
import { defineQuery } from "groq";

const PEOPLE_QUERY = defineQuery(`*[_type == "person"] | order(name asc)`);
const { data: people } = await useSanityQuery(PEOPLE_QUERY);
</script>

<template>
  <UContainer>
    <h1
      class="font-serif text-lg tracking-wide dark:text-gray-200 text-gray-600 mt-6"
    >
      People
    </h1>
    <UPageGrid class="mt-2">
      <PersonCard v-for="person in people" :key="person._id" :person="person" />
    </UPageGrid>
  </UContainer>
</template>
